<template>
  <div id="home">
    <div class="content" v-loading="loading">
      <h1>Smile Camera > <span>Orthodontic Smile</span></h1>
      <el-slider class="slider" :show-tooltip="false" v-model="value"></el-slider>
      <div class="bg" :style="'background-image:url('+(info.statusNew == 'S3' ? getImgS3(info.newImage) : getImg(info.newImage))+')'" v-if="info.newImage">
        <div class="picOld" :style="'width:calc('+value+'% + 1px);'">
          <div class="picOldImg" :style="'background-image:url('+(info.status == 'S3' ? getImgS3(info.oldImage) : getImg(info.oldImage))+')'"></div>
        </div>
      </div>
      <div class="btn">
        <div><span>Original</span></div>
        <div><span>iDentSmile Pick</span></div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
import { getAction } from '@/network/manage';
  export default {
    name: 'OrthodonticSmileShare',
    components: {

    },
    data() {
      return {
        value:50,
        info:'',
        newImage:'',
        oldImage:'',
        loading:false
      }
    },
    computed: {

    },
    created(){
      const that = this
      this.loading = true
      getAction('/admin/caseHistory/queryByIdShare?id='+this.$route.params.uuid).then((res) => {
        if(res.success){
          that.info = res.result
        }else{
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.$message.error(err.message);
      }).finally((res) => {
        this.loading = false
      });
    },
    methods:{
      getImgS3(key) {
        return process.env.VUE_APP_BASE_XA + '/sys/common/test/getImgS3?key=' + key
      },
      getImg(path) {
        return process.env.VUE_APP_BASE_XA + '/sys/common/test/view/' + path
      },
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{padding:20px;}
  .demoImg2{background-image: url(../assets/imgs/imgDemo2.png);}
  .demoImg{background-image: url(../assets/imgs/imgDemo.png);}
  .content{background-color: #ffffff;border-radius: 12px;display: flex;flex-direction: column;width: 800px;align-items: center;margin:0 auto;}
  h1{border-bottom: 1px solid #D9D9D9;height: 60px;display: flex;align-items: center;width: 100%;padding:0 20px;font-size: 16px;}
  h1 span{font-weight: normal;margin-left:10px;}
  .bg{background-size: auto 100%;background-position: center;background-repeat: no-repeat;width: 100%;}
  .picOld{overflow: hidden;border-right: 2px solid #ffffff;}
  .slider{width: 800px;position: absolute;margin-top:calc((100vh - 120px) / 2 )}
  .picOldImg{height:calc(100vh - 180px);width: 800px;background-size: auto 100%;background-position: center;background-repeat: no-repeat;}
  .btn{padding:20px 0;display: flex;width: 80%;margin: 0 auto;}
  .btn div{width: 100%;display: flex;justify-content: center;}
  .btn div span{width: 200px;height: 45px;display: flex;justify-content: center;align-items: center;border-radius: 7px;font-size: 20px;}
  .btn div:last-child span{border:1px solid #8BB2B2;background-color: #9ABDBD;color:#ffffff;}
  >>>.el-slider__runway{background-color: transparent !important;}
  >>>.el-slider__bar{background-color: transparent !important;}
  >>>.el-slider__button{width: 30px;height: 30px;border-color:#ffffff;background-color: rgba(255, 255, 255, 0.3);background-image: url(../assets/imgs/sliderBg.png);background-position: center;}
  @media (max-width: 768px) {
    #home{padding:0;}
    .content{border-radius: 0;width: 100vw;min-height: 100vh;justify-content: flex-start;}
    .slider{width:calc(100vw - 40px);margin-top:80vw;}
    .bg{margin-top:20px;width:calc(100vw - 40px);}
    .picOldImg{width:calc(100vw - 40px);height: 120vw;}
    .btn{width: 100%;}
    .btn div span{width: 150px;font-size: 14px;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    #home{padding:20px;}
  }
</style>
